import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { WifiOff } from 'lucide-react';
import { onlineManager } from '@tanstack/react-query';

function subscribe(onChange: () => void) {
  return onlineManager.subscribe(() => onChange());
}

function getSnapshot() {
  return onlineManager.isOnline();
}

/**
 * T2157 — globalni pas »Ni povezave z internetom«.
 *
 * Vir resnice je `onlineManager` TanStack Queryja, ne neposredno
 * `navigator.onLine`: prav on odloča, ali so poizvedbe zadržane
 * (`fetchStatus: 'paused'`), zato pas govori natanko o stanju, v katerem
 * zasloni kažejo okostje namesto podatkov (`isAwaitingData`, `lib/queryState`).
 * Ob vrnitvi povezave pas izgine, zadržane poizvedbe pa se nadaljujejo same.
 */
export default function OfflineBanner() {
  const { t } = useTranslation();
  const online = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
      className="flex-shrink-0 flex items-center gap-2 border-b border-red-200 bg-red-50 px-4 py-2 text-body text-red-800 dark:border-red-900 dark:bg-red-950 dark:text-red-200"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
      <span>
        <strong className="font-semibold">{t('common.offline_title')}</strong>{' '}
        {t('common.offline_desc')}
      </span>
    </div>
  );
}
